import { ManageComplaintsService } from './../../services/manage-complaints/manage-complaints.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
declare let ga: any;
@Component({
  selector: 'app-manage-complaint-delete-dailogue',
  templateUrl: './manage-complaint-delete-dailogue.component.html',
  styleUrls: ['./manage-complaint-delete-dailogue.component.css'],
})
export class ManageComplaintDeleteDailogueComponent implements OnInit {
  id: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  firstName;
  lastName;
  loginId;
  constructor(public dialogRef: MatDialogRef<ManageComplaintDeleteDailogueComponent>,
              private manageComplaint: ManageComplaintsService  ,
              @Inject(MAT_DIALOG_DATA) public newComplaint : any,
              private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteManageComplaintDetails() {
    this.id= this.newComplaint.deleteComplaintData.ComplaintId;
    this.manageComplaint.deleteManageComplaint(this.id).subscribe(res => {
      ga('CompliantsTracker.send', 'event',this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[2],this.loginId, 1);
      // this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[2],this.loginId, 1);
      if(this.newComplaint.deleteComplaintData.ComplaintStatus == 0){
        this.manageComplaint.load.next('deleted active complaint');
      } else if(this.newComplaint.deleteComplaintData.ComplaintStatus == 1){
        this.manageComplaint.load.next('deleted inactive complaint');
      }
  
      this.onNoClick();
    }, error => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/manage-complaint-delete-dailogue/manage-complaint-delete-dailogue.component.ts